import { Container } from "react-bootstrap";

const ProteccionDatos = () => {
    const liStyle = { textAlign: "left" };

    return (
        <Container className="my-5">
            <h1>Política de Protección de Datos</h1>

            <section className="mt-4">
                <h4>1. RESPONSABLE DEL TRATAMIENTO</h4>
                <p>
                    Yo, Matias Alessandro Contreras, soy el responsable del tratamiento de los datos personales recabados a través de esta web. Puedes contactarme mediante los siguientes datos:
                </p>
                <ul>
                    <li style={liStyle}><strong>Nombre / Razón social:</strong> Matias Alessandro Contreras</li>
                    <li style={liStyle}><strong>NIF:</strong> X3829511B</li>
                    <li style={liStyle}><strong>Domicilio social:</strong> Calle Asarau 20 1º B, 12001 Castellón</li>
                    <li style={liStyle}><strong>Correo electrónico:</strong> No disponible</li>
                    <li style={liStyle}><strong>Teléfono:</strong> 621 06 10 16</li>
                    <li style={liStyle}><strong>Nombre de dominio:</strong> manusfortis.es</li>
                    <li style={liStyle}><strong>Actividad:</strong> Centro de masajes</li>
                </ul>
            </section>

            <section className="mt-4">
                <h4>2. FINALIDAD DEL TRATAMIENTO</h4>
                <p>Los datos personales proporcionados a través de esta web serán tratados con las siguientes finalidades:</p>
                <ul>
                    <li style={liStyle}>Gestionar las consultas y solicitudes realizadas a través de los formularios de contacto.</li>
                    <li style={liStyle}>Enviar información comercial relacionada con los servicios ofrecidos, siempre que hayas otorgado tu consentimiento previo.</li>
                    <li style={liStyle}>Cumplir con obligaciones legales y contractuales.</li>
                </ul>
            </section>

            <section className="mt-4">
                <h4>3. LEGITIMACIÓN DEL TRATAMIENTO</h4>
                <p>La base legal para el tratamiento de tus datos personales es:</p>
                <ul>
                    <li style={liStyle}>Tu consentimiento expreso, otorgado al completar los formularios de contacto y marcar la casilla de aceptación de esta política.</li>
                    <li style={liStyle}>La ejecución de un contrato o la toma de medidas a petición tuya antes de celebrar un contrato.</li>
                    <li style={liStyle}>El cumplimiento de obligaciones legales aplicables al responsable del tratamiento.</li>
                </ul>
            </section>

            <section className="mt-4">
                <h4>4. CONSERVACIÓN DE DATOS</h4>
                <p>
                    Los datos personales se conservarán durante el tiempo necesario para cumplir con la finalidad para la que fueron recabados y para cumplir con las obligaciones legales. En caso de consentimiento para recibir comunicaciones comerciales, los datos se conservarán hasta que se revoque dicho consentimiento.
                </p>
            </section>

            <section className="mt-4">
                <h4>5. DERECHOS DE LOS USUARIOS</h4>
                <p>Tienes derecho a:</p>
                <ul>
                    <li style={liStyle}>Acceder a tus datos personales y obtener información sobre su tratamiento.</li>
                    <li style={liStyle}>Rectificar datos inexactos o incompletos.</li>
                    <li style={liStyle}>Suprimir los datos cuando ya no sean necesarios para la finalidad que motivó su recogida.</li>
                    <li style={liStyle}>Oponerte al tratamiento de tus datos, salvo por motivos legítimos o el ejercicio/defensa de reclamaciones.</li>
                    <li style={liStyle}>Limitar el tratamiento de los datos en determinadas circunstancias.</li>
                    <li style={liStyle}>La portabilidad de los datos, recibiéndolos en formato estructurado y transmitiéndolos a otro responsable cuando sea técnicamente posible.</li>
                    <li style={liStyle}>Revocar el consentimiento otorgado para el tratamiento de tus datos personales.</li>
                </ul>
            </section>

            <section className="mt-4">
                <h4>6. SEGURIDAD DE LOS DATOS</h4>
                <p>
                    He implementado medidas técnicas y organizativas adecuadas para proteger tus datos personales, evitando su pérdida, robo o acceso no autorizado.
                </p>
            </section>

            <section className="mt-4">
                <h4>7. CAMBIOS EN LA POLÍTICA DE PROTECCIÓN DE DATOS</h4>
                <p>
                    Esta política puede modificarse en cualquier momento. Se recomienda revisarla periódicamente para estar informado de cualquier cambio.
                </p>
                <p>
                    Actualizado el 19 de mayo de 2025.
                </p>
                <p>
                    Para cualquier consulta sobre esta política, puedes contactarme mediante los datos proporcionados anteriormente. Tu privacidad es importante y estoy comprometido a garantizar la seguridad y confidencialidad de la información que me proporcionas.
                </p>
            </section>
        </Container>
    );
};

export default ProteccionDatos;
